import { render } from "./CancelButton.vue?vue&type=template&id=0c478e4e"
import script from "./CancelButton.vue?vue&type=script&lang=ts"
export * from "./CancelButton.vue?vue&type=script&lang=ts"
script.render = render

export default script